
import React from 'react';
import { Button } from "@/components/ui/button";
import { Calendar, ThumbsUp, SortAsc, SortDesc } from "lucide-react";

interface SortControlsProps {
  sortBy: "date" | "supports";
  sortOrder: "asc" | "desc";
  onSortChange: (sortBy: "date" | "supports", sortOrder: "asc" | "desc") => void;
}

export const SortControls: React.FC<SortControlsProps> = ({
  sortBy,
  sortOrder,
  onSortChange,
}) => {
  return (
    <div className="flex gap-2">
      <Button
        variant={sortBy === "date" ? "default" : "outline"}
        onClick={() => {
          onSortChange("date", sortOrder === "asc" ? "desc" : "asc");
        }}
        className="flex items-center gap-2 group"
      >
        <Calendar className="h-4 w-4 group-hover:scale-110 transition-transform" />
        Date
        {sortBy === "date" && (
          sortOrder === "asc" ? <SortAsc className="h-4 w-4" /> : <SortDesc className="h-4 w-4" />
        )}
      </Button>
      <Button
        variant={sortBy === "supports" ? "default" : "outline"}
        onClick={() => {
          onSortChange("supports", sortOrder === "asc" ? "desc" : "asc");
        }}
        className="flex items-center gap-2 group"
      >
        <ThumbsUp className="h-4 w-4 group-hover:scale-110 transition-transform" />
        Popularité
        {sortBy === "supports" && (
          sortOrder === "asc" ? <SortAsc className="h-4 w-4" /> : <SortDesc className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
};
